import type { SelectOption } from '@shared/types/form'
import type { CryptoTransactionFilters, CryptoTransactionSort } from '../types/cryptoWalletTypes'

export const DEFAULT_CRYPTO_TRANSACTION_SORT: CryptoTransactionSort = 'newest_first'

/** Sort panel rows, in the order the design lists them. */
export const CRYPTO_TRANSACTION_SORT_OPTIONS: SelectOption[] = [
  { value: 'newest_first', label: 'Newest' },
  { value: 'oldest_first', label: 'Oldest First' },
  { value: 'highest_quantity', label: 'Highest Quantity' },
  { value: 'lowest_quantity', label: 'Lowest Quantity' },
]

/** Server defaults — no status, search, range, newest first. */
export const UNFILTERED_CRYPTO_TRANSACTIONS: Readonly<CryptoTransactionFilters> = {
  search: '',
  status: '',
  sort: DEFAULT_CRYPTO_TRANSACTION_SORT,
  dateFrom: '',
  dateTo: '',
  minQuantity: '',
  maxQuantity: '',
}
